import React, { useContext } from "react";
import {
  Box,
  Button,
  Heading,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Text,
  useToast,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";
import { UserProfileContext } from "../context/UserContext";
import { hasUserType, USER_TYPES } from "../utils/userRole";
import EstateList from "./AccountSwitcher/EstateList";

const RequireAccountGate = () => {
  const { userProfile, isLoading, activeAccount, setActiveAccount } =
    useContext(UserProfileContext) || {};
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();

  const onInvitationPage = location.pathname.startsWith("/invitations/");
  if (onInvitationPage) return null;

  const estates = Array.isArray(userProfile?.estates)
    ? userProfile.estates
    : [];
  const isVtu = hasUserType(userProfile, USER_TYPES.VTU_USER);
  const hasMultipleChoices =
    estates.length > 1 || (estates.length > 0 && isVtu);

  const isBlocking = !isLoading && !activeAccount && hasMultipleChoices;

  const handleSelectEstate = (estate) => {
    const resolvedEstate = estate?.estateId || estate;
    const acc = {
      type: "estate",
      estateId: resolvedEstate?._id || resolvedEstate,
      name:
        resolvedEstate?.estateName ||
        resolvedEstate?.name ||
        String(resolvedEstate),
      isPrimary: !!estate?.isPrimary,
    };
    setActiveAccount?.(acc);
    toast({
      title: `Switched to ${acc.name}`,
      status: "success",
      duration: 2500,
      isClosable: true,
    });
    navigate("/dashboard");
  };

  const handleSelectVtu = () => {
    setActiveAccount?.({ type: "vtu", name: "VTU Account" });
    toast({
      title: "Switched to VTU account",
      status: "success",
      duration: 2500,
      isClosable: true,
    });
    navigate("/vtu");
  };

  if (isLoading) return null;

  return (
    <Modal
      isOpen={isBlocking}
      onClose={() => {}}
      closeOnOverlayClick={false}
      closeOnEsc={false}
      isCentered
      size="md"
    >
      <ModalOverlay backdropFilter="blur(2px)" />
      <ModalContent>
        <ModalHeader>
          <Heading size="md">Select an Account</Heading>
        </ModalHeader>
        <ModalBody pb={6}>
          <Text mb={4} color="gray.600">
            Choose which account you want to use for this session.
          </Text>
          <EstateList
            estates={estates}
            onSelectEstate={handleSelectEstate}
            isVtu={isVtu}
            onSelectVtu={handleSelectVtu}
            activeAccount={activeAccount}
            buttonLabel="Use this account"
          />
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default RequireAccountGate;
